import {RootState} from '../../rootReducer';

export const getControlsForNode = (nodeId: string) => (state: RootState) => state.data.controls.controlsByNode[nodeId];
